import slice from './slice';

export const { resetOrderState, setOrderState, setOrderError } = slice.actions;

export { fetchOrderStateThunk as fetchOrderState } from './thunks';
